import envVar from '../config/envVars';
import {
  AttendanceSource,
  StaffAttendanceView
} from '../modules/StaffAttendance/types';
import httpGet from './httpClient/httpGet';
import httpPost from './httpClient/httpPost';

interface StaffAttendanceRequest {
  school: string;
  date: string | null;
  role: string | null;
  status?: string;
}

const fetchStaffAttendanceData = ({
  school,
  date,
  role,
  status
}: StaffAttendanceRequest) => {
  const url = `${envVar.REACT_APP_BASE_API_URL}/staff-attendance/schools/${school}/date/${date}?role=${role}&status=${status}`;
  return httpGet(url);
};

interface StaffAttendanceUpsertRequest {
  school: string;
  date: string;
  staffAttendanceData: StaffAttendanceView[];
  source: AttendanceSource;
}

const upsertStaffAttendanceData = ({
  school,
  date,
  staffAttendanceData,
  source
}: StaffAttendanceUpsertRequest) => {
  const url = `${envVar.REACT_APP_BASE_API_URL}/staff-attendance/schools/${school}/date/${date}`;
  return httpPost(url, { userAttendanceData: staffAttendanceData, source });
};

interface ImportStaffAttendanceRequest {
  school: string;
  file: File;
}
interface ImportStaffAttendanceResponse {
  successfulRecords: number;
  unsuccessfulRecords: {
    'Employee Code': string;
    AttendanceDate: string;
    StatusCode: string;
    InTime: string;
    OutTime: string;
    error: string;
  }[];
}

const importStaffAttendance = ({
  school,
  file
}: ImportStaffAttendanceRequest) => {
  const url = `${envVar.REACT_APP_BASE_API_URL}/staff-attendance/attendance-logs/import`;
  const formData = new FormData();
  formData.append('file', file);
  formData.append('school', school);

  return httpPost(
    url,
    null,
    { headers: { 'Content-Type': 'multipart/form-data' } },
    formData
  ) as unknown as ImportStaffAttendanceResponse;
};

const staffAttendanceApis = {
  fetchStaffAttendanceData,
  upsertStaffAttendanceData,
  importStaffAttendance
};

export default staffAttendanceApis;
